exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-body[data-v-17217051]{padding:0;margin:0}.workhour-button[data-v-17217051]{font-size:small;padding:0;margin:0}.hidden[data-v-17217051]{visibility:hidden}.red-button[data-v-17217051],.red-button[data-v-17217051]:hover{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-17217051&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/ia/WorktimeEditableHour.vue
// module id = 234
// module chunks = 0